// components/CockpitHomeMark.tsx — H2 (COCKPIT-HOME-COLUMNS-SPEC.md §H2):
// "the Vowric logo at the top of the Mist strip → #/home" / "a Vowric logo
// mark at the start of the top bar (beside the title switcher) → #/home".
//
// ⚑ JUDGEMENT CALL (reported in the build's own final message): no blessed
// graphic brand mark exists anywhere in this codebase to reuse. The only
// existing "Vowric mark" on screen is Knot.tsx's canvas glyph — but that is
// the CAPTURE identity (animated, voice-state-driven, S1c's own "no mic
// anywhere in the cockpit" rule sits right next to it), never used to mean
// anything else; pressing it to also mean "go home" would give the one mark
// Huan already owns a second, conflicting meaning. Login.tsx's only other
// Vowric reference is a plain text wordmark. Rather than invent new brand
// artwork Huan hasn't blessed (design-hat's own rule — direction before new
// surface archetypes), this ships a plain, unbranded monogram: a static
// ring + "V" stroke, no colour/canvas/motion of its own, painted entirely
// from the pack's existing --cl-*/--hair/--ink tokens so it carries no new
// palette decision either.
//
// A plain anchor (`href="#/home"`) rather than a button: it is, in fact, a
// link to a route, and an anchor is reachable, labelled and keyboard-
// focusable for free. `onNavigate` still runs (preventDefault + the SAME
// path every other door in this pack uses — routes/route.ts's
// `routePath({screen:'home'})`), so going home is the ONE navigate() call
// site, not a second ad hoc hash assignment that could drift from it.
import './CockpitHomeMark.css';

export interface CockpitHomeMarkProps {
  onNavigate: () => void;
}

export function CockpitHomeMark({ onNavigate }: CockpitHomeMarkProps) {
  return (
    <a
      href="#/home"
      class="chmark"
      aria-label="Home"
      onClick={(e) => {
        e.preventDefault();
        onNavigate();
      }}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
        <circle cx="10" cy="10" r="8.5" class="chmark__ring" />
        <path d="M5.5 6.5l4.5 8 4.5-8" class="chmark__v" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </a>
  );
}
